import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgManometerGoed = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#B3E9B1"
      d="M20 35c8.284 0 15-6.716 15-15S28.284 5 20 5 5 11.716 5 20s6.716 15 15 15"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M20 5.25a.5.5 0 0 1 .5.5v4.29a.5.5 0 0 1-1 0V5.75a.5.5 0 0 1 .5-.5M11.373 8.008a.5.5 0 0 1 .7.105l2.56 3.47a.5.5 0 1 1-.805.594l-2.56-3.47a.5.5 0 0 1 .105-.7M6.044 15.217a.5.5 0 0 1 .629-.323l4.15 1.33a.5.5 0 1 1-.306.952l-4.15-1.33a.5.5 0 0 1-.323-.629M11.147 22.508a.5.5 0 0 1-.325.629l-4.15 1.32a.5.5 0 0 1-.304-.954l4.15-1.32a.5.5 0 0 1 .628.325M28.854 22.508a.5.5 0 0 1 .628-.325l4.15 1.32a.5.5 0 1 1-.303.953l-4.15-1.32a.5.5 0 0 1-.325-.628M33.956 15.217a.5.5 0 0 1-.323.63l-4.15 1.33a.5.5 0 0 1-.306-.953l4.15-1.33a.5.5 0 0 1 .63.323M28.627 8.008a.5.5 0 0 1 .105.699l-2.56 3.47a.5.5 0 1 1-.804-.594l2.56-3.47a.5.5 0 0 1 .699-.105"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      d="M35 20a15 15 0 1 1-30 0 15 15 0 0 1 30 0M20 7.5a12.5 12.5 0 1 0 0 25 12.5 12.5 0 0 0 0-25"
    />
    <path
      fill="#60D15D"
      d="M14.54 15.53h1.09V14l-.71.4-.46-.76 1.28-1h1v2.93h1v1h-3.2zM20 10.88 21.5 20a1.52 1.52 0 1 1-3 .49 1.4 1.4 0 0 1 0-.49z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgManometerGoed);

export default ForwardRef;
